import { render, staticRenderFns } from "./M_heroLanding.vue?vue&type=template&id=50538f77&"
import script from "./M_heroLanding.vue?vue&type=script&lang=js&"
export * from "./M_heroLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports